import {CheckInItem} from './checkin-item.model';

export class NewBusinessTransaction extends CheckInItem {
    public businessTransactionAreaId: number;
    public customerNumberId: number;
    public businessTransactionParamId: number;
    public businessTransactionParamTypeId: number;

    // TODO: ADD OPTIONAL PARAMETER ARRAY FOR CHECKIN OPTIONS
    // Below is a temporary solution to allow a 2nd param to be exposed
    public businessTransactionParam2Id: number;
    public businessTransactionParamType2Id: number;

    public transactionDescription: string;
    public suggestionReason: string;
    public appointmentId: string;
    public appointmentDate: Date;
    public locationId: number;
}
